import { render, staticRenderFns } from "./AmpereLawViz.vue?vue&type=template&id=e0277956&scoped=true"
import script from "./AmpereLawViz.vue?vue&type=script&lang=js"
export * from "./AmpereLawViz.vue?vue&type=script&lang=js"
import style0 from "./AmpereLawViz.vue?vue&type=style&index=0&id=e0277956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0277956",
  null
  
)

export default component.exports